// Turks (tr-TR), languagesApp: zelfde vorm als languagesApp.nl.ts. Wat ontbreekt valt terug op het
// Nederlands (nooit een rauwe sleutel op het scherm).
export const appLanguagesTr = {
    title: 'Dil',
    settingsBody: 'Uygulamayı, tabletleri ve e-postaları hangi dilde göreceğin',
    welcomeTitle: 'Hoş geldiniz. Evde hangi dili konuşuyorsunuz?',
    welcomeBody: 'Ailenin dilini seç. Bunu daha sonra Ayarlar bölümünden her zaman değiştirebilirsin.',
    continue: 'Devam',
    household: 'Ailenin dili',
    householdHint: 'Uygulama, tabletler ve e-postalar için. Başka bir şey seçmedikçe her aile üyesi ve her tablet bu dili kullanır.',
    saved: 'Dil kaydedildi',
    partial: 'Henüz her şey çevrilmedi. Eksik kalanlar Felemenkçe görünür.',
    digitsTitle: 'Rakamlar',
    digitsLatin: 'Normal rakamlar',
    digitsArabic: 'Arap rakamları',
    digitsHint: 'Saatler ve sayılar için, tabletlerde ve uygulamada.',
    overridesTitle: 'Ayrı bir dil',
    overridesBody: 'Biri başka bir dili mi tercih ediyor, ya da bir odada tablet mi var? Bunu Aile ve Tabletler bölümünden seç.',
    overridesOff: 'Kişi ya da tablet başına ayrı dil kapalı. Modüller bölümünden açabilirsin.',
    toMembers: 'Aile bölümüne git',
    toDevices: 'Tabletler bölümüne git',
    sameAsFamily: 'Ailedeki gibi ({language})',
    memberLabel: 'Dil',
    memberHint: 'Uygulama ve e-postalar için: {name}.',
    deviceLabel: 'Bu tabletin dili',
    deviceHint: 'Bir odadaki tablet için kullanışlı. Seçmezsen ailenin dilini kullanır.',
    deviceSaved: '{name} artık bu dilde: {language}',
    ownLanguage: 'Dil: {language}',
    authLabel: 'Dil',
};
//# sourceMappingURL=languagesApp.tr.js.map